import {
  FC,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';

import { ColorTheme } from 'enum/ColorTheme';
import { UTC } from '../AppTimeInput/AppTimeInput';
import AppSelectSearch from '../AppSelect/AppSelectSearch';

import './AppTimeZoneSelect.scss';

interface IComponentProps {
  name?: string;
  formItemName?: string;
  onChange: (value: string) => void;
  selectedOption?: string | null;
  dataTestId?: string;
  className?: string;
  disableClearable?: boolean;
  theme?: ColorTheme,
}

const AppTimeZoneSelect: FC<IComponentProps> = ({
  name,
  formItemName = '',
  onChange,
  dataTestId,
  selectedOption = UTC,
  className = '',
  disableClearable = false,
  theme,
}) => {
  const { t, i18n } = useTranslation('translation');

  const [timeZones, setTimeZones] = useState<string[]>([]);

  const selectName = useMemo(() => name ?? t('timezone'), [name, i18n.language]);

  useEffect(() => {
    setTimeZones([UTC, ...Intl.supportedValuesOf('timeZone')]);
  }, []);

  return (
    <AppSelectSearch
      name={selectName}
      className={`timezone-select ${className}`}
      formItemName={formItemName}
      options={timeZones}
      onChangeValue={onChange}
      getOptionLabel={(option) => option}
      selectedOption={selectedOption}
      dataTestId={dataTestId}
      disableClearable={disableClearable}
      theme={theme}
    />
  );
};

export default AppTimeZoneSelect;
